import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plan-comptable-show',
  templateUrl: './plan-comptable-show.component.html',
  styleUrls: ['./plan-comptable-show.component.scss']
})
export class PlanComptableShowComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
